import { weekFilterEnum } from "../../types/types"
import { PlacementsAction, PlacementsActionType, SponsoredProductState } from "../types/placements"

const initialState: SponsoredProductState = {
  childData: {
    placementSubResult: [],
    dataTableResult: [],
    datePeriodType: weekFilterEnum.DAY,
  },
  isLoading: false,
  error: null,
}

export const placementsReducer = (
  state = initialState,
  action: PlacementsAction
): SponsoredProductState => {
  switch (action.type) {
    case PlacementsActionType.FETCH_PLACEMENTS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case PlacementsActionType.FETCH_PLACEMENTS_SUCCESS: {
      const incomingPlacements = (action.payload.placementSubResult ?? []).filter(
        (placement) => placement
      )
      const incomingPlacementIds = new Set(
        incomingPlacements.map((placement) => String(placement.campaignId))
      )
      const incomingTables = (action.payload.dataTableResult ?? []).filter((dataTable) => dataTable)
      const incomingTableIds = new Set(
        incomingTables.map((dataTable) => String(dataTable.campaignId))
      )

      return {
        childData: {
          ...action.payload,
          placementSubResult: state.childData.placementSubResult
            .filter(
              (placement) => placement && !incomingPlacementIds.has(String(placement.campaignId))
            )
            .concat(incomingPlacements),
          dataTableResult: state.childData.dataTableResult
            .filter((dataTable) => dataTable && !incomingTableIds.has(String(dataTable.campaignId)))
            .concat(incomingTables),
        },
        isLoading: false,
        error: null,
      }
    }

    case PlacementsActionType.FETCH_PLACEMENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
